import {
	primaryPurposeOptions,
	userTypeOptions,
	title,
} from '../../utils/const';

export const setProfileData = (rawData) => {
	const {
		user_profile: {
			age,
			childrenAge,
			user_type,
			gender,
			primary_purpose,
			whatsappNumber,
			isParent,
			receiveWhatsappNotification,
			isMobVerified,
			isSubscribe,
		},
		full_name,
		phone,
		email,
	} = rawData;

	let userType =
		user_type !== '' && userTypeOptions.indexOf(user_type) === -1
			? 'Others'
			: user_type;

	let primaryPurpose =
		primary_purpose !== '' &&
		primaryPurposeOptions.indexOf(primary_purpose) === -1
			? 'Others'
			: primary_purpose;

	return {
		fullName: !!full_name ? full_name : '',
		phone: !!phone ? phone : '',
		email: !!email ? email : '',
		gender,
		age,
		userType,
		whatsappNumber,
		childrenAge,
		isParent,
		primaryPurpose,
		receiveWhatsappNotification,
		isMobVerified,
		isSubscribe,
		userTypeOther:
			user_type !== '' && userTypeOptions.indexOf(user_type) === -1
				? user_type
				: '',
		primaryPurposeOther:
			primary_purpose !== '' &&
			primaryPurposeOptions.indexOf(primary_purpose) === -1
				? primary_purpose
				: '',
		...showHideUserType(userType),
	};
};

export const showHideUserType = (val) => {
	if (val === '') {
		return { additionalSection: 'None' };
	} else {
		return {
			title: title[val],
			additionalSection: 'block',
			fieldGraduateYear: val === 'Student' ? 'block' : 'none',
			fieldUserJob: val === 'Working Professional' ? 'block' : 'none',
			fieldJobType: val === 'Working Professional' ? 'block' : 'none',
			fieldPreparingExam: val === 'Competitive Exam Aspirant' ? 'block' : 'none',
			fieldSkills: val === 'Competitive Exam Aspirant' ? 'block' : 'none',
			fieldPrimaryPurpose: val !== 'Competitive Exam Aspirant' ? 'block' : 'none',
		};
	}
};

export const handleInputChange = (event, aspectToDevelop) => {
	let target = event.target;
	let value = target.value;
	let name = target.name;
	if (name === 'isEnglishMedium') {
		value = value === 'true' ? true : false;
	}
	if (name === 'aspectToDevelop') {
		if (target.checked === true) {
			aspectToDevelop.push(value);
		} else {
			aspectToDevelop = aspectToDevelop.filter((item) => item !== value);
		}
		value = aspectToDevelop;
	}

	return {
		[name]: value,
	};
};
